<template>
  <div>
    <div class="container">
      <div class="style-box-top">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane v-if="codeData.includes('435')" label="绩效明细" name="first"></el-tab-pane>
          <el-tab-pane v-if="codeData.includes('438')" label="州县绩效统计" name="second"></el-tab-pane>
          <el-tab-pane v-if="codeData.includes('440')" label="县内绩效统计" name="third"></el-tab-pane>
        </el-tabs>
      </div>
      <PerformanceDetails v-if="activeName==='first'"></PerformanceDetails>
      <StatePerformance v-if="activeName==='second'"></StatePerformance>
      <CountyPerformance v-if="activeName==='third'"></CountyPerformance>
    </div>
  </div>
</template>

<script>
//创建时间：2023/10/25 09:50:56
import PerformanceDetails from "./performance_details.vue";
import StatePerformance from "./state_performance.vue";
import CountyPerformance from "./county_performance.vue";
export default {
  components: {
    PerformanceDetails,
    StatePerformance,
    CountyPerformance
  },
  data() {
    return {
      activeName: null,
      codeData:[]
    }
  },
  methods: {},
  mounted() {
    let codeData = JSON.parse(sessionStorage.getItem('menuData'));
    this.codeData = codeData;
    this.activeName = codeData.includes("435")?'first':codeData.includes("438")?'second':"third"
  },
}
</script>

<style scoped lang="less">
.container {
  .style-box-top {
    padding: 24px 24px 0;
  }
}
</style>